<template>
  <ul>
    <div class="tw-text-gray-600 tw-mb-1">Your Home Location</div>
    <li class="tw-border tw-rounded-md tw-py-4 tw-px-6">
      <div class="tw-flex tw-items-center tw-justify-between">
        <div>
          <span>{{ homeLocation.name }}</span>
          <base-phone-number-field :value="homeLocation.phoneNumber" :isHyperlinkActive="false" class="tw-text-gray-600 tw-text-sm">{{
            homeLocation.name
          }}</base-phone-number-field>
        </div>
        <base-button type="secondary" class="tw-rounded-full tw-pl-2 tw-pr-2" @click="call(homeLocation.phoneNumber)"><phone-icon class="tw-h-5 tw-w-5"/></base-button>
      </div>
    </li>
    <div class="tw-text-gray-600 tw-mt-10 tw-mb-1">Other Locations</div>
    <li
      v-for="location in locations.filter((location) => location.businessLocationId !== homeLocation.businessLocationId)"
      :key="location.businessLocationId"
      class="tw-border tw-rounded-md tw-py-4 tw-px-6 tw-mb-3"
    >
      <div class="tw-flex tw-items-center tw-justify-between">
        <div>
          <span>{{ location.name }}</span>
          <base-phone-number-field :value="location.phoneNumber" :isHyperlinkActive="false" class="tw-text-gray-600 tw-text-sm">{{ location.name }}</base-phone-number-field>
        </div>
        <base-button type="secondary" class="tw-rounded-full tw-pl-2 tw-pr-2" @click="call(location.phoneNumber)"><phone-icon class="tw-h-5 tw-w-5"/></base-button>
      </div>
    </li>
  </ul>
</template>
<script>
import { PhoneIcon } from "@/assets/svgs";

export default {
  components: {
    PhoneIcon,
  },
  props: {
    businessName: String,
    locations: Array,
    homeLocation: Object,
  },
  methods: {
    call(number) {
      window.open("tel:" + number, "_self");
    },
  },
};
</script>
